import script from "./Select.vue?vue&type=script&setup=true&lang=ts"
export * from "./Select.vue?vue&type=script&setup=true&lang=ts"

import "./Select.vue?vue&type=style&index=0&id=37e47e74&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37e47e74"]])

export default __exports__